// MetaModel
class MetaModel {
  constructor(httpStatusCode, errorType, errorMessage) {
    this.httpStatusCode = httpStatusCode;
    this.errorType = errorType;
    this.errorMessage = errorMessage;
  }

  static fromJson(json) {
    if (json == null) {
      return null;
    }
    return new MetaModel(
      json["httpStatusCode"],
      json["errorType"],
      json["errorMessage"]
    );
  }

  toJson() {
    return {
      httpStatusCode: this.httpStatusCode,
      errorType: this.errorType,
      errorMessage: this.errorMessage,
    };
  }
}

export { MetaModel };
